import React, {PropTypes} from 'react';
import {__} from '../../../server/lib/i18n-2/browserHelper'
import {formatMoneyNoCurrency} from'../../lib/utils'

console.log("__", __('projectBla'))

const Project = (props) => {
  const handleClick = (e) => {
    props.dataLayer.push({
      event: 'button',
      btntype: 'ZOBRAZIT DETAIL'
    })
  }

  const projectDetailOrPopup =
    props.isUserLoggedIn &&
    (<a href={props.absoluteUrl} onClick={(e) => handleClick(e)} className="btn-classic btn-wide btn-blue">
      {__('ZOBRAZIT DETAIL')}
    </a>)
    ||
    <div dangerouslySetInnerHTML={{ __html: props.buttonPopupShortCode}} />

    const image =
      props.image && (
        <div className="left">
          <img className="header-img" src={props.thumb} alt="header image of a project"/>
        </div>
      )


  return (
  <div className="item logged">
    <div className="content-section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="content header-section align-left">
                {image}
              <div className="inline hdr header-2 header-text padded-light">
                {props.title}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 text-section">
            <div className="container-fluid underlined-links">
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">
                    {__('VÝŠE INVESTiCE')}:
                    </div>
                    <span className="light-blue">
                      {formatMoneyNoCurrency(props.investment, props.lang)} {props.investmentCurrency}</span>
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">
                      {__('POZNÁMKA k VÝŠI INVESTICE')}:
                    </div>
                    {props.investmentNote}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">
                      {__('PŘEDPOKLÁDANÉ ZHODNOCENÍ')}:
                    </div>
                    <span className="light-blue">
                      {props.roi}
                    </span>
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('STATUS')}:</div>
                    {props.status && props.status.name}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('RIZIKOVOST')}:</div>
                    {props.riskiness && props.riskiness.name}
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style"></div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('Obor')}:</div>
                    <div className="content tags">
                      {props.tags.map((t, k) => <a style={{display: 'block'}} key={k} href={t.absoluteUrl}>{t.name}</a>)}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('KATEGORIE')}:</div>
                    <div className="content category">
                      {props.categories.map((t, k) => <a style={{display: 'block'}} key={k} href={t.absoluteUrl}>{t.name}</a>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 long-text-section">
            <div className="simple-textbox-component" id="vyhody-textbox-top">
              <div className="item text-style dark-underlined-links">
                <div className="small-padding no-margin hdr header-3 header-text dark-grey align-left">
                  {props.perex}
                </div>
                <div className="text-style align-left text-content text-narrow-alt" dangerouslySetInnerHTML={{__html: props.shortText}} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="centered content">
              {projectDetailOrPopup}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Project



// WEBPACK FOOTER //
// ./src/browser/components/stateless/Project.react.js